import {trans} from '@frontend/helpers'
import {
    useEffect,
    useState,
} from 'react'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import type {AdPreviewDataForGrid} from '../../AdsModuleTypes'
import {PublicAdsApi} from '../../PublicAdsApi'
import {AdsGridItem} from './AdsGridItem'

const adsToLoad: number = 3

interface Props {
    className?: string
    standalone?: boolean
}

// Список ранее просмотренных объявлений.
export function RecentlyViewedAds(props: Props) {

    const [
        viewedAds,
        setViewedAds,
    ] = useState<AdPreviewDataForGrid[]>([])

    // Загрузка списка просмотренных объявлений.
    useEffect(() => {
        PublicAdsApi.getViewedAds(null, adsToLoad)
            .then((ads: AdPreviewDataForGrid[]) => {
                setViewedAds(ads)
            })
            .catch(() => {
            })
    }, [])

    if (viewedAds.length === 0) {
        return null
    }

    const renderAds = () => viewedAds.map((advertisement: AdPreviewDataForGrid) => (
        <AdsGridItem
            key={'viewed-' + advertisement.id}
            ad={advertisement}
        />
    ))

    return (
        <Collapse show={viewedAds.length > 0}>
            <div className={props.className}>
                {props.standalone ? (
                    <div>
                        <div className="mb-4 fw-500 fs-5">
                            {trans().ads.list.viewed_ads}:
                        </div>
                        <div className="d-grid grid-columns-2 col-gap-4 row-gap-4 grid-columns-md-2 grid-columns-lg-3 grid-columns-xl-4">
                            {renderAds()}
                        </div>
                    </div>
                ) : (
                    <Card>
                        <CardBody className="pb-3 pt-3">
                            <div className="mb-2 fw-500 fs-5">
                                {trans().ads.list.viewed_ads}:
                            </div>
                            <div className="d-flex flex-column align-items-stretch justify-content-start gap-6">
                                {renderAds()}
                            </div>
                        </CardBody>
                    </Card>
                )}
            </div>
        </Collapse>
    )
}
